// extracted by mini-css-extract-plugin
export default {"CreateReportTemplate":"create-report-template_CreateReportTemplate__jTOga"};